module.exports = __webpack_public_path__ + "static/img/2.0b68e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/2.png
// module id = rXbI
// module chunks = 0